export const WISHLIST_ACTION = {
  GET_WISHLIST: "WISHLIST_ACTION/GET_WISHLIST",
  ADD_WISHLIST: "WISHLIST_ACTION/ADD_WISHLIST",
  REMOVE_WISHLIST: "WISHLIST_ACTION/REMOVE_WISHLIST",
};
